// Keeps the product page's price and "Add to cart" label in step with the
// quantity field, so the shown price is what the customer will pay.
// Delegated from document so it runs after variant_pricing.js resets the price
// on variant change, and binds once across Turbolinks visits.
var currency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
})

function formatCents(cents) {
  return currency.format(cents / 100).replace(/\.00$/, "")
}

// Shrinks the add-to-cart total only when the Seats row would overflow the card
// (it starts at the CSS size), so long totals stay readable and inside it.
function fitTotal(el) {
  if (!el || !el.classList.contains("add-to-cart-total")) return

  var row = el.parentElement
  el.style.fontSize = ""
  var size = parseFloat(getComputedStyle(el).fontSize)
  while (row.scrollWidth > row.clientWidth && size > 12) {
    size -= 1
    el.style.fontSize = size + "px"
  }
}

function syncQuantityPricing(form) {
  var $form = $(form)
  var $qty = $form.find(".js-add-to-cart-qty")
  if (!$qty.length) return

  var $price = $(".js-price-cart").first()
  var $button = $form.find(".js-item-addToCart")
  var $variant = $form.find(".js-product-variantPrice:checked")
  var qty = Math.min(Math.max(parseInt($qty.val(), 10) || 1, 1), 99)
  var $priced = $variant.length ? $variant : $qty
  // Prices render as e.g. "11999.0", which jQuery leaves as a string; parse so
  // the sum below adds instead of concatenating.
  var unitCents = parseFloat(
    $variant.length
      ? $variant.data("price-cents")
      : $qty.data("unit-price-cents")
  )
  // An upgrade or renewal price covers the first copy only; the rest pay this.
  var additionalCents = parseFloat($priced.data("additional-price-cents"))
  if (isNaN(additionalCents)) additionalCents = unitCents

  // Single-product pricing can carry sale/renewal strikethrough markup; keep it
  // so quantity 1 looks exactly as it did before any edits.
  if ($price.data("originalHtml") === undefined) {
    $price.data("originalHtml", $price.html())
  }

  if (qty > 1 && !isNaN(unitCents)) {
    $price.text(formatCents(unitCents + additionalCents * (qty - 1)))
  } else if ($variant.length) {
    $price.text($variant.data("price"))
  } else {
    $price.html($price.data("originalHtml"))
  }

  fitTotal($price[0])
  $button.val(qty > 1 ? "Add " + qty + " to cart" : "Add to cart")
}

$(document).on(
  "input change",
  ".js-add-to-cart-qty, .js-product-variantPrice",
  function () {
    syncQuantityPricing(this.form)
  }
)

// UJS restores the button's pre-submit label ("Add 3 to cart") when the request
// completes, after the response has reset the quantity; re-sync once it's done.
$(document).on("ajax:complete", "form", function () {
  var form = this
  setTimeout(function () {
    syncQuantityPricing(form)
  }, 0)
})

// After an add, "Added! View Cart" stands in for the button. Picking another
// variant or quantity brings the button back so that selection can be added too.
$(document).on(
  "input change",
  ".js-add-to-cart-qty, .js-product-variantPrice",
  function () {
    var $form = $(this.form)
    if (!$form.find(".js-add-to-cart-result").length) return

    $form.find(".js-add-to-cart-result").remove()
    $form.find(".js-item-addToCart").removeClass("d-none")
  }
)

// Size the total for the page's starting price and width too, not only after a change.
$(document).on("turbolinks:load", function () {
  $(".js-add-to-cart-qty").each(function () {
    syncQuantityPricing(this.form)
  })
})

$(window).on("resize", function () {
  $(".add-to-cart-total").each(function () {
    fitTotal(this)
  })
})
